<template>
  <div>
    <v-toolbar color="primary" fixed app dense>
      <v-toolbar-title class="subheading"> COFFEE DSS </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-app>
    <v-content>
      <v-container>
        <v-layout row justify-center wrap>
        <v-flex xs12 lg8 md8>
          <v-card elevation-12>
            <v-card-title>
              <h3 class="headline mb-2 primary--text" color="secondary">Complete Registration</h3>
            </v-card-title>
            <v-card-text>
              <v-alert v-if="!tokenValid" :value="true" color="error"> {{ tokenInvalidMessage }} </v-alert>
             <v-form ref="form" v-model="valid" lazy-validation>
              <v-flex xs12>
                <v-text-field
                  name="email"
                  label="Username"
                  v-model="user.email"
                  readonly
                  required>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="password"
                  label="Password"
                  v-model="user.password"
                  :type="'password'"
                  :rules="passwordRules"
                  required>
                </v-text-field>
                <v-list v-if="passwordValidationError">
                    <template v-for="(item, index) in passwordErrors">
                      <v-list-item color="error" :key="index">
                        <v-list-item-content>
                          {{ item }}
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                </v-list>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="confirmPassword"
                  label="Confirm Password"
                  v-model="user.confirmPassword"
                  :type="'password'"
                  :rules="confirmPasswordRules"
                  required>
                </v-text-field>
              </v-flex>
             </v-form>
              </v-card-text>
             <v-card-actions>
                <v-btn @click="confirmUser" color="secondary">Submit</v-btn>
             </v-card-actions>
          </v-card>
      </v-flex>
    </v-layout>
        </v-container>
    </v-content>
    </v-app>
    <v-footer color="primary" app inset>
      <div class="white--text">
      <strong>Copyright &copy; {{year}}
        Co-operative Bank</strong> All rights reserved.
      </div>
    </v-footer>
  </div>
</template>

<script>
import config from '../config'
import axios from 'axios'

export default {
  name: 'completereg',
  data: function () {
    return {
      year: new Date().getFullYear(),
      message: '',
      confirmToken: '',
      response: '',
      tokenValid: true,
      tokenInvalidMessage: '',
      user: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      valid: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length > 7) || 'Password length should be atleast 8 characters'
      ],
      confirmPasswordRules: [
        v => !!v || 'Confirm Password Field is required',
        v => (v && v === this.user.password) || 'Confirm Password must match password field'
      ],
      passwordValidationError: false,
      passwordErrors: []
    }
  },
  mounted () {
    var urlString = window.location.href
    var url = new URL(urlString)
    var t = url.searchParams.get('token')
    this.confirmToken = t
    console.log(t)
    this.getTokenDetails()
  },
  methods: {
    getTokenDetails () {
      const url = config.serverURI + '/confirm/user?token=' + this.confirmToken
      axios
        .get(url)
        .then(response => {
          var data = response.data
          if (data.error === true) {
            this.tokenValid = false
            this.tokenInvalidMessage = data.message
          } else {
            this.user.email = data.message
          }
        })
        .catch(error => {
          console.log(error)
          this.tokenInvalidMessage = 'Server appears to be offline'
        })
    },
    confirmUser () {
      this.message = ''
      this.error = ''
      this.passwordErrors = []
      if (this.$refs.form.validate()) {
        var url = config.serverURI + '/confirm/completereg'
        axios.post(url, this.user)
          .then(response => {
            if (response.data.valid === false) {
              this.passwordErrors = response.data.passwordErrors
              this.passwordValidationError = true
              return
            }
            if (response.data.error === true) {
              this.tokenValid = false
              this.tokenInvalidMessage = response.data.message
              return
            }
            if (response.data.error !== false) {
              this.tokenInvalid = true
              this.tokenInvalidMessage = response.data.message
              return
            } else {
              window.location = '/login?message=' + response.data.message
            }

            this.resetUserObject()
            this.$refs.form.reset()
            this.message = response.data.message
          })
          .catch(error => {
            console.log('error', error.response)
          })
      }
    }
  }
}
</script>

<style>
</style>
